import { Mesocycle } from "../types";

export interface MesocycleTemplate {
  name: string;
  description: string;
  create: () => Omit<Mesocycle, "id">;
}

export const mesocycleTemplates: MesocycleTemplate[] = [
  {
    name: "Arms Specialization",
    description:
      "5-day program focused on arm development with supporting muscle groups",
    create: () => ({
      name: "Arms Specialization",
      startDate: new Date().toISOString(),
      endDate: new Date(Date.now() + 8 * 7 * 24 * 60 * 60 * 1000).toISOString(),
      weeks: Array.from({ length: 8 }, (_, weekIndex) => ({
        weekNumber: weekIndex + 1,
        sessions: [
          {
            dayOfWeek: 1,
            name: "Monday - Triceps/Chest/Biceps/Back",
            exercises: [
              {
                name: "Barbell Skullcrusher",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 15,
              },
              {
                name: "Dumbbell Press (Flat)",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 22,
              },
              {
                name: "EZ Bar Curl (Narrow Grip)",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 15,
              },
              {
                name: "Pulldown (Underhand Grip)",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 27.5,
              },
            ],
          },
          {
            dayOfWeek: 2,
            name: "Tuesday - Quads/Hamstrings/Shoulders",
            exercises: [
              {
                name: "Barbell Squat (High Bar)",
                sets: 3,
                targetRepsPerSet: 8,
                targetWeight: 50,
              },
              {
                name: "Lying Leg Curl",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 55,
              },
              {
                name: "Machine Lateral Raise",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 32,
              },
            ],
          },
          {
            dayOfWeek: 3,
            name: "Wednesday - Biceps/Back/Triceps/Chest",
            exercises: [
              {
                name: "Dumbbell Curl (Incline)",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 8,
              },
              {
                name: "EZ Bar Row (Underhand)",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 30,
              },
              {
                name: "Cable Triceps Pushdown (Bar)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 26,
              },
              {
                name: "Pushup (Deficit)",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 0,
              },
            ],
          },
          {
            dayOfWeek: 4,
            name: "Thursday - Hamstrings/Quads/Shoulders",
            exercises: [
              {
                name: "Stiff-Legged Deadlift",
                sets: 3,
                targetRepsPerSet: 8,
                targetWeight: 50,
              },
              {
                name: "Leg Press",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 140,
              },
              {
                name: "Dumbbell Lateral Raise",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 8,
              },
            ],
          },
          {
            dayOfWeek: 5,
            name: "Friday - Triceps/Chest/Biceps/Back",
            exercises: [
              {
                name: "EZ Bar Overhead Triceps Extension",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 26,
              },
              {
                name: "Dumbbell Press (Incline)",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 22,
              },
              {
                name: "Freemotion Curl (Facing Away)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 10,
              },
              {
                name: "Assisted Pullup (Underhand Grip)",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 12.5,
              },
            ],
          },
        ],
      })),
      active: true,
    }),
  },
  {
    name: "Black Adam Workout",
    description: "5-day split with upper body specialization",
    create: () => ({
      name: "Black Adam Workout",
      startDate: new Date().toISOString(),
      endDate: new Date(Date.now() + 8 * 7 * 24 * 60 * 60 * 1000).toISOString(),
      weeks: Array.from({ length: 8 }, (_, weekIndex) => ({
        weekNumber: weekIndex + 1,
        sessions: [
          {
            dayOfWeek: 1,
            name: "Monday",
            exercises: [
              {
                name: "Barbell Bent Over Row",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 30,
              },
              {
                name: "Assisted Pullup (Normal Grip)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 12.5,
              },
              {
                name: "Bench Press (Incline, Medium Grip)",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 35,
              },
              {
                name: "Dumbbell Press (Flat)",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 22,
              },
              {
                name: "Cable Rope Facepull",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 13,
              },
            ],
          },
          {
            dayOfWeek: 2,
            name: "Tuesday",
            exercises: [
              {
                name: "Lying Biceps Dumbbell Curl",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 8,
              },
              {
                name: "Barbell Skullcrusher",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 15,
              },
              {
                name: "Bench Press (Narrow Grip)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 15,
              },
              {
                name: "Lying Leg Curl",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 55,
              },
              {
                name: "Hack Squat",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 40,
              },
            ],
          },
          {
            dayOfWeek: 3,
            name: "Wednesday",
            exercises: [
              {
                name: "Bench Press (Medium Grip)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 35,
              },
              {
                name: "Dumbbell Press (Low Incline)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 22,
              },
              {
                name: "Cable Upright Row",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 26,
              },
              {
                name: "Machine Chest Supported Row",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 72.5,
              },
              {
                name: "Cable Flexion Row",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 27,
              },
            ],
          },
          {
            dayOfWeek: 4,
            name: "Thursday",
            exercises: [
              {
                name: "Stiff-Legged Deadlift",
                sets: 3,
                targetRepsPerSet: 8,
                targetWeight: 50,
              },
              {
                name: "Leg Press",
                sets: 3,
                targetRepsPerSet: 10,
                targetWeight: 40,
              },
              {
                name: "Lying Down Curl",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 55,
              },
              {
                name: "Cable Triceps Pushdown (Bar)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 16,
              },
              {
                name: "Pushup",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 0,
              },
            ],
          },
          {
            dayOfWeek: 5,
            name: "Friday",
            exercises: [
              {
                name: "Dumbbell Upright Row",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 10,
              },
              {
                name: "Pullup (Underhand Grip)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 12.5,
              },
              {
                name: "Barbell Flexion Row",
                sets: 3,
                targetRepsPerSet: 15,
                targetWeight: 20,
              },
              {
                name: "Machine Chest Press",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 25,
              },
              {
                name: "Smith Machine Press (Incline, Medium Grip)",
                sets: 3,
                targetRepsPerSet: 12,
                targetWeight: 30,
              },
            ],
          },
        ],
      })),
      active: true,
    }),
  },
];
